import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Box, Typography, Paper, ListItem, ListItemText, Stack, CircularProgress, Skeleton } from '@mui/material';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
import { NotificationContext } from 'contexts';
import { getTranslation } from 'common';
import { useTranslations } from 'hooks';
import { NotificationContextType } from 'contexts/notificationContext';


type RowProps = {
    index: number;
    style: Object;
};


const NotificationsList = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const translations = useTranslations()
    const HEADER_HEIGHT = 65;
    const { actions: { readNotification }, state: { notificationList } } = useContext<NotificationContextType>(NotificationContext)

    const allNotifications = useMemo(() => notificationList, [notificationList]);
    // const navigateToNotification = () => {
    //     console.log("da implementare")
    // }

    const Row: React.FC<RowProps> = React.memo(({ index, style }) => {
        const notification = allNotifications[index];
        if (!notification) return null;

        return (
            <ListItem
                id={`notif-${String(notification.id)}`}
                data-cy="notification-item"   // ✅ attributo stabile per Cypress
                divider
                style={{ ...style, cursor: notification.readed ? "default" : "pointer", }}
                // onMouseEnter={() => {
                //     if (!notification.readed) {
                //         readNotification({ id: notification.id });
                //     }
                // }}
                onClick={() => {
                    if (!notification.readed) {
                        readNotification({ id: notification.id });
                    }
                }}
                disabled={notification.readed}
            >
                <ListItemText
                    primary={
                        <Typography
                            sx={{ fontWeight: notification.readed ? 'normal' : 'bold' }}
                        >
                            {notification.notificationtext}
                        </Typography>
                    }
                />
            </ListItem>
        );
    });

    useEffect(() => {
        setLoading(true)
    }, [])


    return (
        <React.Fragment>
            {allNotifications.length === 0 ?
                <Box height={40} display={"flex"} alignItems="center" justifyContent="center">
                    <Typography textAlign={"center"}>{getTranslation(translations, "notifications.no_notifications")}</Typography>
                </Box> :
                <Stack
                    sx={{
                        flex: 1,
                        maxHeight: `100%`,
                        borderRadius: "15px",
                    }}
                >
                    <Typography variant="h4" gutterBottom mt={4} ml={4}>
                        {getTranslation(translations, "menu.left.notifications")}
                    </Typography>
                    <Box
                        component={Paper}
                        sx={{
                            maxHeight: `calc(100% - ${HEADER_HEIGHT}px})`,
                            height: `calc(100% - ${HEADER_HEIGHT}px)`,
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            pb: 2,
                            position: "relative"
                        }}>
                        {loading &&
                            <Box sx={{ px: 2, position: "absolute", inset: 0 }}>
                                {Array.from(Array(10).keys()).map((k) => <Skeleton variant="rectangular" width="100%" height={50} sx={{ borderRadius: 2, my: "5px" }} key={`skeleton-${k}`} />)}
                            </Box>
                        }

                        <AutoSizer style={{ height: `calc(100% - ${HEADER_HEIGHT}px)`, minHeight: 500, width: 100 }}>
                            {({
                                height,
                                width,
                            }: {
                                height: number;
                                width: number;
                            }) => (
                                <FixedSizeList
                                    onItemsRendered={() => setLoading(false)}
                                    height={height}
                                    width={width}
                                    itemSize={80}
                                    itemCount={allNotifications.length}
                                >
                                    {Row}
                                </FixedSizeList>
                            )}
                        </AutoSizer>
                    </Box>
                </Stack>
            }
        </React.Fragment >
    );
};

export default NotificationsList